import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { AuthenticatedTemplate } from '@azure/msal-react';
import { App as AntdApp } from 'antd';

import { Auth, Azure, Config, Theme } from '@app/web-components';

import { getConfig } from './app/config';
import { router } from './app/routes';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const config = getConfig();

root.render(
  <StrictMode>
    <AntdApp>
      <Theme.ConfigProvider>
        <Config.ConfigContextProvider config={config.app}>
          <Azure.AppMsalProvider config={config}>
            <Auth.UserAuthProvider baseUrl={config.apiMain} scopes={config.sso.scopes}>
              <AuthenticatedTemplate>
                <RouterProvider router={router} />
              </AuthenticatedTemplate>
            </Auth.UserAuthProvider>
          </Azure.AppMsalProvider>
        </Config.ConfigContextProvider>
      </Theme.ConfigProvider>
    </AntdApp>
  </StrictMode>,
);
